import React, { FC, useContext } from 'react'
import moment from 'moment'
import { Dropdown } from '../../../../System'
import { SkeletonLoader } from '../../../../SkeletonLoader'
import { StyledOverview } from '.'
import { userStore } from '../../../../utils/UserContext'
import useAffiliateDashboard from '../../../AffiliateDashboard/useAffiliateDashboard'

const Overview: FC = () => {
  const { user } = useContext(userStore)
  const {
    loading,
    dateRange,
    totalEarnings,
    totalSales,
    totalClicks,
    trialingUsers,
    actions: { setDateRange }
  } = useAffiliateDashboard()

  return (
    <StyledOverview>
      <div className="heading overview">
        <h2>Overview</h2>
        <div className="date-options">
          <span className="joined-label">
            Joined {moment.utc((user?.becameAffiliate?.seconds || 0) * 1000).format('YYYY')}
          </span>
          <Dropdown
            value={dateRange}
            options={[
              {
                label: 'Last 10 Days',
                value: '10'
              },
              {
                label: 'Last 30 Days',
                value: '30'
              },
              {
                label: 'Last 90 Days',
                value: '90'
              },
              {
                label: 'Current Year',
                value: 'year'
              }
            ]}
            onChange={(e) => setDateRange(e.value)}
            isClearable={false}
          />
        </div>
      </div>

      <div className="overview-metrics">
        {loading && <SkeletonLoader type="caption-list-item" quantity={4} />}
        {!loading && (
          <>
            <div className="overview-metric">
              <span className="metric-label">Total Earnings</span>
              <span className="metric-value">${totalEarnings.toFixed(2)}</span>
            </div>
            <div className="overview-metric">
              <span className="metric-label">Total Clicks</span>
              <span className="metric-value">{totalClicks}</span>
            </div>
            <div className="overview-metric">
              <span className="metric-label">Total Sales</span>
              <span className="metric-value">{totalSales}</span>
            </div>
            <div className="overview-metric">
              <span className="metric-label">Trialing Users</span>
              <span className="metric-value">{trialingUsers}</span>
            </div>
          </>
        )}
      </div>
    </StyledOverview>
  )
}

export default Overview
